// @ts-ignore
import { PROBLEM_INNER_TYPES } from '@yandex-int/k-common/constants';

import { ProblemCoding } from './types';

export function isCodingProblem(problem: { type: string } | null | undefined): problem is ProblemCoding {
    return problem?.type === PROBLEM_INNER_TYPES.CODING;
}

export function catchAll<T>(fn: () => T): T | undefined {
    try {
        return fn();
    } catch (e) {
        return undefined;
    }
}
